import { ApplicationState } from '~/store/store';

export const getHeatTransferState = (state: ApplicationState) => state.room.data.heatTransfer;
